import { render, staticRenderFns } from "./BeneficiaryLeaderBoard.vue?vue&type=template&id=4e1712d6&scoped=true&lang=html&"
import script from "./BeneficiaryLeaderBoard.vue?vue&type=script&lang=js&"
export * from "./BeneficiaryLeaderBoard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e1712d6",
  null
  
)

export default component.exports